<template>
    <b-modal v-model="show" title="Устунларни созлаш" :no-close-on-esc="true" :no-close-on-backdrop="true" class="excel-settings-modal">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <h4>Устун тартибини созлаш</h4>
                    <button class="all-btn add-btn mx-0 my-2" @click="addColumn">Қўшиш (қўшилмайдиган майдон)</button>
                    <draggable
                            class="list-group"
                            tag="ul"
                            v-bind="dragOptions"
                            @start="drag=true"
                            @end="drag=false"
                            :move="onMove"
                            v-model="list">
                        <transition-group type="transaction" :name="!drag ? 'flip-list' : null">
                            <li class="list-group-item" v-for="(element,index) in list" :key="element.order">
                                {{element.name}}
                                <span class="badge badge-secondary badge-pill">{{element.order}}</span>
                                <i v-if="element.code==='OTHER_COLUMN'" class="fa fa-times close" @click="removeAt(index)"></i>
                            </li>
                        </transition-group>
                    </draggable>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="colSortDone">
                Тасдиклаш
            </button>
            <button class="all-btn float-right mr-2" @click="sort">
                Тартиблаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import draggable from 'vuedraggable'
    import {EXCEL_SETTINGS} from '@/shared/constants/reEvaluateSettings'

    let id = 11;

    export default {
        name: "ExcelSettingsModal",
        components: {
            'b-modal': bModal,
            draggable
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                list: EXCEL_SETTINGS,
                list2: [],
                editable: true,
                drag: false,
                delayedDragging: false
            }
        },
        methods: {
            cancel() {
                this.show = false
            },
            sort() {
                this.list = this.list.sort((a,b) => a.order - b.order)
            },
            colSortDone() {
                const resultList = this.list.map((result,index) => ({code: result.code, order: index + 1}));
                this.$emit('change', resultList);
                this.show = false;
            },
            onMove({ relatedContext, draggedContext }) {
                const relatedElement = relatedContext.element;
                const draggedElement = draggedContext.element;
                return (
                    (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
                );
            },
            addColumn() {
                this.list.push({name: "Бошқа(қўшилмайдиган майдон)", code: "OTHER_COLUMN",order: id++,fixed: false})
            },
            removeAt(order) {
                this.list.splice(order, 1);
            }
        },
        created() {
            this.$eventBus.$on("showSettings", () => {
                this.show = true
            })
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: 'description',
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        }
    }
</script>

<style>
    .excel-settings-modal .modal-dialog {
        max-width: 400px;
        width: 400px !important;
    }
    .excel-settings-modal .modal-content {
        width: 400px !important;
    }
    .list-group-item {
        cursor: move;
        height: 45px;
        align-items: center;
        justify-content: space-between;
        display: flex;
    }
    .list-group-item i {
        cursor: pointer;
    }
</style>